
import { useEffect, useState } from 'react';

import Util, { Data } from 'service/util';

import MediaTypeDropdown from 'component/dropdown/MediaTypeDropdown';
import LocationSelect from 'component/dropdown/LocationSelect';

const EReceiptSelectionFilter = ({onChange}) => {

  const [company,    setCompany  ] = useState('');
  const [district,   setDistrict ] = useState('');
  const [location,   setLocation ] = useState('');
  const [cd_license, setLicense  ] = useState('');
  const [media_type, setMediaType] = useState('');

  useEffect(() => {
    onChange({company, district, location, cd_license, media_type});
  }, [company, district, location, cd_license, media_type])

  return (<div className="box e-invoice-filter">
    <h4 className="box-head">過濾</h4>
    <div className="box-body">
      <label className="field-row company">
        <strong>公司</strong>
        <div>
          <select id="f-company" value={company}
            onChange={ e=>setCompany(e.target.value) }>
            <option value="">全部</option>
            { Data.company.map(com =>
              <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
            )}
          </select>
        </div>
      </label>
      <label className="field-row location">
        <strong>屋苑</strong>
        <div>
          <LocationSelect all noLabel by={'management'}
            district={district} location={location}
            onUpdate={(d,l) => { setDistrict(d); setLocation(l); }}
            />
        </div>
      </label>
      <label className="field-row license">
        <strong>車牌</strong>
        <div>
          <input value={cd_license} onChange={ e=>setLicense(e.target.value)} />
        </div>
      </label>
      <label className="field-row media-type">
        <strong>媒體類型</strong>
        <div>
          <MediaTypeDropdown value={media_type} onChange={setMediaType} />
        </div>
      </label>
    </div>
  </div>);
}

export default EReceiptSelectionFilter;